import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";
import {getUserId} from "@/utils/auth";

//用于生成uuid
function S4() {
  return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
}
function guid() {
  return (S4()+S4()+""+S4()+""+S4()+""+S4()+""+S4()+S4()+S4());
}


let systemId=1

// 加载所有
export function eventCollect(params={}){
    let uuid= localStorage.getItem("uuid");
    if(!uuid){
      uuid=guid();
      localStorage.setItem("uuid",uuid)
    }

    let userId = getUserId();
    if(userId){
      params.userId=userId;
    }
    params.systemId=systemId;
    params.uuid=uuid;
    return http.postForm("/event/collect",params);
  }





// WEBPACK FOOTER //
// ./src/services/event.js